module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAHklEQVQImWM41Jr5/9WVVf8lRFT/MzEgAQSHgYEBAPSpB2uWMJwVAAAAAElFTkSuQmCC"